import clsx from 'clsx';
import React from 'react';

const AnchorActivityItem = (props) => {
  const { filename, actionTypeLabel, onClickFile } = props;
  const readOnly = onClickFile ? false : true;

  if (readOnly) {
    return (
      <React.Fragment>
        <span className={clsx('tw-text-cfo-black')}> {actionTypeLabel} </span>
        <strong
          className={clsx(
            'tw-text-cfo-blue-600 tw-font-brandonTextBold !tw-font-normal tw-underline'
          )}
        >
          {filename}
        </strong>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <span className={clsx('tw-text-cfo-black')}> {actionTypeLabel} </span>
      <a
        className={clsx(
          'tw-font-brandonTextBold tw-text-cfo-blue-600 tw-underline',
          'hover:!tw-underline'
        )}
        onClick={onClickFile}
        aria-hidden="true"
      >
        {filename}
      </a>
    </React.Fragment>
  );
};

export default AnchorActivityItem;
